/**
 * Content Verification Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedModelOfPartnerContentVerificationModel } from '../model/paginatedModelOfPartnerContentVerificationModel';
import { PartnerContentVerificationModel } from '../model/partnerContentVerificationModel';
import { ProblemDetails } from '../model/problemDetails';
import { Request } from '../model/request';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContentVerificationsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param partnerId 
     * @param serviceProviderId 
     * @param code 
     * @param accessKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsContentVerification(partnerId?: string, serviceProviderId?: string, code?: string, accessKey?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentVerificationModel>;
    public contentVerificationsContentVerification(partnerId?: string, serviceProviderId?: string, code?: string, accessKey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentVerificationModel>>;
    public contentVerificationsContentVerification(partnerId?: string, serviceProviderId?: string, code?: string, accessKey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentVerificationModel>>;
    public contentVerificationsContentVerification(partnerId?: string, serviceProviderId?: string, code?: string, accessKey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }
        if (accessKey !== undefined && accessKey !== null) {
            queryParameters = queryParameters.set('access_key', <any>accessKey);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/ContentVerification`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public contentVerificationsDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public contentVerificationsDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public contentVerificationsDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/ContentVerifications/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param partnerId 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsGetAllContentByCreatorIdAndPartnerIdWithPagination(serviceProviderId?: string, partnerId?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfPartnerContentVerificationModel>;
    public contentVerificationsGetAllContentByCreatorIdAndPartnerIdWithPagination(serviceProviderId?: string, partnerId?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfPartnerContentVerificationModel>>;
    public contentVerificationsGetAllContentByCreatorIdAndPartnerIdWithPagination(serviceProviderId?: string, partnerId?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfPartnerContentVerificationModel>>;
    public contentVerificationsGetAllContentByCreatorIdAndPartnerIdWithPagination(serviceProviderId?: string, partnerId?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfPartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/GetAllContentByCreatorIdAndPartnerIdWithPagination`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsGetAllContentByCreatorIdWithPagination(serviceProviderId?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfPartnerContentVerificationModel>;
    public contentVerificationsGetAllContentByCreatorIdWithPagination(serviceProviderId?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfPartnerContentVerificationModel>>;
    public contentVerificationsGetAllContentByCreatorIdWithPagination(serviceProviderId?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfPartnerContentVerificationModel>>;
    public contentVerificationsGetAllContentByCreatorIdWithPagination(serviceProviderId?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfPartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/GetAllContentByCreatorIdWithPagination`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsGetContentByCreatorId(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentVerificationModel>;
    public contentVerificationsGetContentByCreatorId(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentByCreatorId(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentByCreatorId(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/GetContentByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsGetContentByCreatorIdAndPartnerId(serviceProviderId?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentVerificationModel>;
    public contentVerificationsGetContentByCreatorIdAndPartnerId(serviceProviderId?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentByCreatorIdAndPartnerId(serviceProviderId?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentByCreatorIdAndPartnerId(serviceProviderId?: string, partnerId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/GetContentByCreatorIdAndPartnerId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsGetContentById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentVerificationModel>;
    public contentVerificationsGetContentById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentVerificationModel>>;
    public contentVerificationsGetContentById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/GetContentById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsInsert(model: Request, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentVerificationModel>;
    public contentVerificationsInsert(model: Request, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentVerificationModel>>;
    public contentVerificationsInsert(model: Request, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentVerificationModel>>;
    public contentVerificationsInsert(model: Request, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling contentVerificationsInsert.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PartnerContentVerificationModel>(`${this.basePath}/api/ContentVerifications/Insert`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contentVerificationsUpdate(model: PartnerContentVerificationModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public contentVerificationsUpdate(model: PartnerContentVerificationModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public contentVerificationsUpdate(model: PartnerContentVerificationModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public contentVerificationsUpdate(model: PartnerContentVerificationModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling contentVerificationsUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/ContentVerifications/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
